export enum WebSocketEventName {
  ERROR = "error",
  CONNECT = "connect",
  VIDEO_EXPORT_DONE = "video_export_done",
  EPISODE_GENERATED = "episode_generated",
  EPISODE_PROCESSING_FAILED = "episode_processing_failed",
  EPISODE_INSIGHTS_GENERATED = "episode_insights_generated",
}
